import { BlogAction } from "./blog/blog.slice";
import { BlogArticleAction } from "./blogArticle/blogArticle.slice";
import { CheckSSRActions } from "./check-ssr/check-ssr.slice";
import { ClientAction } from "./client/clientSlice";
import { ContentActions } from "./content/content.slice";
import { CurrentDateActions } from "./current-date/current-date.slice";
import { FreeProxyAction } from "./freeProxy/freeProxySlice";
import { LanguagesAction } from "./languages/languageSlice";
import { MainPageActions } from "./main-page/main-page.slice";
import { MobileMenuActions } from "./mobileMenu/mobileMenu.slice";

export const StoreActions = {
  ...MainPageActions,
  ...CheckSSRActions,
  ...CurrentDateActions,
  ...ContentActions,
  ...MobileMenuActions,
  ...ClientAction,
  ...FreeProxyAction,
  ...BlogAction,
  ...BlogArticleAction,
  ...LanguagesAction,
};
